import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "stat-tile__value" }
const _hoisted_2 = { class: "stat-tile__label" }
const _hoisted_3 = {
  key: 0,
  class: "stat-tile__hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.to ? 'router-link' : 'div'), {
    to: _ctx.to,
    class: _normalizeClass(["stat-tile", [`stat-tile--${_ctx.tone}`, { 'stat-tile--link': _ctx.to }]])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.value), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
      (_ctx.hint)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.hint), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to", "class"]))
}